import React from 'react'
import PropTypes from 'prop-types'

import injectIntl from './injectIntl'
import IntlProvider from './IntlProvider'
import FormattedMessage from './FormattedMessage'
import FormattedHTMLMessage from './FormattedHTMLMessage'
import Message from './Message'
import intlMessageShape from './intlMessageShape'


const defineMessages = (messages) => messages


export {
  intlMessageShape,
  defineMessages,
  injectIntl,
  IntlProvider,
  FormattedMessage,
  FormattedHTMLMessage,
  Message,
}
